// extracted by mini-css-extract-plugin
export var attribution = "_b8-4";
export var authorName = "_b8-5";
export var quote = "_b8-3";
export var testimonial = "_b8-2";
export var trustedBy = "_b8-0";
export var trustedByLabel = "_b8-1";